module.exports = __webpack_public_path__ + "img/wormhole.b4441cdd.png";